const state = {
    total: 0,
    participation: 0,
    accommodation: 0,
    meal: 0,
    activity: 0,
    resource: 0,
    nbt: 0,
    vat: 0,
    currency: 'USD'
};

const getters = {
    getTotal: state => state.participation + state.accommodation + state.meal + state.activity + state.nbt + state.vat + state.resource,
    getCurrency: state => state.currency
};

const actions = {
    addToTotal({ commit }, data) {
        commit('setAmount', data)
    },
    changeCurrency({ commit }, data) {
        commit('setCurrency', data)
    }
};

const mutations = {
    setAmount: (state, data) => {
        state[data['type']] = parseFloat(data['total']);
    },
    setCurrency: (state, data) => {
        state.currency = data;
    }  
};

export default {
    state,
    getters,
    actions,
    mutations
}